import { z } from "zod";

export const RequestHelperGetPrepopInfoInputSchema = z.object({
    requestTypeId: z.number(),
});

export type RequestHelperGetPrepopInfoInput = z.infer<typeof RequestHelperGetPrepopInfoInputSchema>;